import { AuthLayout } from "../components/AuthLayout";
import { EmailAuthForm } from "../components/EmailAuthForm";
import { useRedirectIfAuthed } from "../components/RouteGuards";
import { useNoindex } from "../hooks/useNoindex";

export default function AdminLogin() {
  useNoindex();
  useRedirectIfAuthed();
  return (
    <AuthLayout testId="admin-login-page" eyebrow="Staff only" title="Admin sign in" subtitle="For Real Match Matrimony administrators and sub-admins.">
      <EmailAuthForm mode="staff_login" />
    </AuthLayout>
  );
}
